<template>
  <Tooltip>
	<template v-slot:element>
	  <span>
		Monetarisierung
	  </span>
	  <InformationCircleIcon class="info-icon" />
	</template>
	<template v-slot:content>
	  <span>
		Bewertung, wie gut die Methode dabei helfen kann Kaufabschlüsse zu befeuern
	  </span>
	</template>
  </Tooltip>
</template>

<style scoped>
.info-icon
{
  @apply h-5 w-5 inline-block;
  @apply text-gray-400;
}
</style>
